﻿import { PriceDiscount } from "./PriceDiscount";

export class PriceDiscountLevel implements IPriceDiscountLevel {
    constructor(level?: IPriceDiscountLevel, discount?: PriceDiscount) {
        // initialize typed object from generic object
        this._discount = discount;
        this._discountCode = level?.discountCode ?? "";
        this.minQuantity = level?.minQuantity ?? 1;
        this.maxQuantity = level?.maxQuantity;
        this.amountOrPercent = level?.amountOrPercent ?? 0;
        this.compound = level?.compound ?? false;
    }

    toJSON(): object {
        // return generic object with properties to stringify
        return {
            minQuantity: this.minQuantity,
            maxQuantity: this.maxQuantity,
            amountOrPercent: this.amountOrPercent,
            compound: this.compound
        };
    }

    get discountCode(): string {
        return this._discount ? this._discount.discountCode : this._discountCode;
    };

    set discountCode(value: string) {
        this._discountCode = value;
    }

    minQuantity: number;
    maxQuantity?: number;
    amountOrPercent: number;
    compound: boolean;

    private _discount?: PriceDiscount;
    private _discountCode: string;

    // Calculated properties

    get quantityText(): string {
        if (!this.maxQuantity)
            return `${this.minQuantity}+`;
        if (this.minQuantity === this.maxQuantity)
            return `${this.minQuantity}`;
        return `${this.minQuantity}-${this.maxQuantity}`;
    }
}

export interface IPriceDiscountLevel {
    discountCode: string;
    minQuantity: number;
    maxQuantity?: number;
    amountOrPercent?: number;
    compound?: boolean;
}